import { combineReducers } from 'redux';
import globalSlice from './ducks/Global';
import entitySlice from './ducks/DataEntry/Entities';
import tppSlice from './ducks/DataEntry/ThirdPartyProviders';
import branchSlice from './ducks/DataEntry/Branch';
import functionSlice from './ducks/DataEntry/Functions';
import ICTServiceSlice from './ducks/DataEntry/ICTServices/ICTServiceSlice';
import contractualInformationSlice from './ducks/DataEntry/ContractualInformation';
import reportingSlice from './ducks/Reportings';
import article8Slice from './ducks/DataManagement/Article8AndICTSystem';

export default combineReducers({
  global: globalSlice.reducer,
  entities: entitySlice.reducer,
  tpp: tppSlice.reducer,
  branch: branchSlice.reducer,
  function: functionSlice.reducer,
  ictServices: ICTServiceSlice.reducer,
  contractualInformation: contractualInformationSlice.reducer,
  reportings: reportingSlice.reducer,
  article8: article8Slice.reducer,
});
